// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"60":"c04db81387f404c9","6665":"1932b9c84b6d0ca6"}[chunkId] + ".css";
};